import { useEffect, useState } from "react";
import { api } from "../../App";
import { mono, Btn, Input, PageTitle } from "./ptUi";

// Tracker Settings (admin) — manage the extra dropdown options (brands, studios,
// departments, item types) that layer on top of Dream Machine's own data.

function ListManager({ title, hint, items, onChange }) {
  const [val, setVal] = useState("");
  const add = () => { const v = val.trim(); if (!v || items.includes(v)) return; onChange([...items, v]); setVal(""); };
  return (
    <div style={{ background: "var(--s1)", border: "1px solid var(--bdr)", borderRadius: "var(--radius-sm)", padding: 16 }}>
      <div style={{ fontFamily: mono, fontSize: 12, fontWeight: 700, color: "var(--t1)", marginBottom: 8 }}>{title}</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 10 }}>
        {items.map((i) => (
          <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "var(--s2)", borderRadius: 20, padding: "3px 10px", fontFamily: mono, fontSize: 11, color: "var(--t2)" }}>
            {i}<span onClick={() => window.confirm(`Remove "${i}"?`) && onChange(items.filter((x) => x !== i))} style={{ cursor: "pointer", color: "var(--t4)" }}>×</span>
          </span>
        ))}
        {items.length === 0 && <span style={{ fontFamily: mono, fontSize: 11, color: "var(--t4)" }}>None yet.</span>}
      </div>
      <form onSubmit={(e) => { e.preventDefault(); add(); }} style={{ display: "flex", gap: 8 }}>
        <Input value={val} onChange={(e) => setVal(e.target.value)} placeholder={`Add to ${title.toLowerCase()}…`} />
        <Btn type="submit">Add</Btn>
      </form>
      {hint && <div style={{ fontFamily: mono, fontSize: 10, color: "var(--t4)", marginTop: 8 }}>{hint}</div>}
    </div>
  );
}

export default function PtrackerSettings() {
  const [s, setS] = useState(null);
  const [err, setErr] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => { api.get("/ptracker/settings").then((r) => setS(r.data)).catch((e) => setErr(e.response?.data?.detail || "Couldn't load settings.")); }, []);

  const save = (key) => (arr) => {
    const next = { ...s, [key]: arr };
    setS(next);
    api.put("/ptracker/settings", { [key]: arr }).then(() => { setSaved(true); setTimeout(() => setSaved(false), 1500); }).catch((e) => setErr(e.response?.data?.detail || "Save failed — admins only."));
  };

  return (
    <div style={{ padding: "24px 28px", maxWidth: 900, margin: "0 auto" }} data-testid="ptracker-settings">
      <PageTitle title="Tracker Settings" sub="Extra dropdown options layered on top of Dream Machine's own clients, studios and departments." right={saved ? <span style={{ fontFamily: mono, fontSize: 11, color: "#0ca30c" }}>✓ Saved</span> : null} />
      {err && <div style={{ color: "var(--r)", fontFamily: mono, fontSize: 12, marginBottom: 12 }}>{err}</div>}
      {s && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))", gap: 12 }}>
          <ListManager title="Item types" hint="Content formats on Daily Tasks." items={s.item_types || []} onChange={save("item_types")} />
          <ListManager title="Extra brands" hint="Beyond Dream Machine's client list." items={s.extra_brands || []} onChange={save("extra_brands")} />
          <ListManager title="Extra studios" hint="Rooms not in Dream Machine's studio list." items={s.extra_studios || []} onChange={save("extra_studios")} />
          <ListManager title="Extra departments" hint="Beyond Dream Machine's departments." items={s.extra_departments || []} onChange={save("extra_departments")} />
        </div>
      )}
    </div>
  );
}
